import { FC } from 'react';
import { UNTITLED_VIDEO_NAME } from './config';

type Props = {
  isFailed?: boolean;
  isLoading?: boolean;
  url: string;
  name: string;
};

export const VideoCardTablePreview: FC<Props> = ({
  isFailed = false,
  isLoading = false,
  url,
  name,
}) => {
  return (
    <div className="flex flex-nowrap items-center gap-x-3 min-w-0">
      {!isFailed && !isLoading && (
        <img
          src={url}
          alt="video"
          className="object-cover w-14 h-8 rounded-[4px] border border-base-black/[0.08] flex-shrink-0"
        />
      )}
      <p className="text-md font-semibold truncate text-gray-900">
        {name || UNTITLED_VIDEO_NAME}
      </p>
    </div>
  );
};
